import { makeApiCall } from '../_common/api.utils';
import { API_URL } from '../const';

/** ***************** GET COUNTRY LIST START *********************** */
export const getAllCountriesList = (country: any) => {
	const data = {
		GetCountryListToken: country,
	};
	const url = `${API_URL}fetchCountryList`;
	return makeApiCall(url, data);
};
/** ***************** GET COUNTRY LIST END *********************** */

/** ***************** GET STATE LIST START *********************** */

export const getAllStateList = (state: any) => {
	const data = {
		CountryStateListGetToken: state,
	};
	const url = `${API_URL}fetchCountryStateList`;
	return makeApiCall(url, data);
};
/** ***************** GET STATE LIST END *********************** */

/** ***************** GET CITY LIST START *********************** */
export const getAllCityList = (city: any) => {
	const data = {
		StateCityListGetToken: city,
	};
	const url = `${API_URL}fetchStateCityList`;
	return makeApiCall(url, data);
};
/** ***************** GET CITY LIST END *********************** */

/** ***************** GET PINCODE LIST START *********************** */
export const getAllPincodeList = (postCodeData: any) => {
	const data = postCodeData;
	const url = `https://api.postalpincode.in/pincode/${data}`;
	return makeApiCall(url, null, 'GET');
};
/** ***************** GET PINCODE LIST END *********************** */

/** ***************** GET DISTRICT LIST START *********************** */
export const getDistrictList = (district: any) => {
	const data = {
		DistrictCityListGetToken: district,
	};
	const url = `${API_URL}fetchStateDistrictList`;
	return makeApiCall(url, data);
};
/** ***************** GET DISTRICT LIST END *********************** */

/** ***************** GET ALL INDUSTRY LIST START *********************** */

export const getAllIndustryList = (fetchIndustryData: any) => {
	const data = {
		FetchIndustryToken: fetchIndustryData,
	};
	const url = `${API_URL}fetchIndustryList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL INDUSTRY LIST END *********************** */

/** ***************** GET ALL SUB INDUSTRY LIST START *********************** */
export const getSubIndustryList = (subIndustryData: any) => {
	const data = {
		FetchSubIndustryListToken: subIndustryData,
	};
	const url = `${API_URL}fetchSubIndustryList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL SUB INDUSTRY LIST END *********************** */

/** ***************** GET ALL BRANCH LIST START *********************** */
export const allBranchesFetch = (fetchBranchesData: any) => {
	const data = {
		FetchAllBranchKeyToken: fetchBranchesData,
	};
	const url = `${API_URL}fetchAllBranches`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL BRANCH LIST END *********************** */

/** ***************** GET ALL PURPOSE OF LOAN TYPE LIST START *********************** */
export const allPurposeOfLoanTypeFetch = (fetchPurposeOfLoanTypeData: any) => {
	const data = {
		FetchAllPurposeOfLoanTypeListToken: fetchPurposeOfLoanTypeData,
	};
	const url = `${API_URL}fetchAllPurposeOfLoanTypeList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL PURPOSE OF LOAN TYPE LIST END *********************** */

/** ***************** GET ALL PURPOSE OF LOAN LIST START *********************** */
export const allPurposeOfLoanListFetch = (fetchPurposeOfLoanTypeData: any) => {
	const data = {
		FetchAllPurposeOfLoanListToken: fetchPurposeOfLoanTypeData,
	};
	const url = `${API_URL}fetchAllPurposeOfLoanList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL PURPOSE OF LOAN LIST END *********************** */

/** ***************** GET ALL BUSINESS DETAILS LIST START *********************** */
export const allBusinessDetailsFetch = (fetchBusinessListData: any) => {
	const data = {
		GetAllBusinessListToken: fetchBusinessListData,
	};
	const url = `${API_URL}getAllBusinessList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL BUSINESS DETAILS LIST END *********************** */

/** ***************** GET ALL PRODUCT TYPE LIST START *********************** */
export const allProductTypeFetch = (fetchBranchesData: any) => {
	const data = {
		FetchAllProductTypeListToken: fetchBranchesData,
	};
	const url = `${API_URL}fetchAllProductTypeList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL PRODUCT TYPE LIST END *********************** */

/** ***************** GET ALL PRODUCT LIST START *********************** */
export const allProductsFetch = (fetchAllProductData: any) => {
	const data = {
		FetchAllProductListToken: fetchAllProductData,
	};
	const url = `${API_URL}GetAllProductList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL PRODUCT LIST END *********************** */

/** ***************** GET ALL BRANCH OFFICER LIST START *********************** */
export const allBranchOfficerFetch = (fetchBranchOfficerData: any) => {
	const data = {
		GetBranchAllOfficerListToken: fetchBranchOfficerData,
	};
	const url = `${API_URL}fetchAllBranchOfficer`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL BRANCH OFFICER LIST END *********************** */

/** ***************** GET ALL CENTER LIST START *********************** */
export const allCenterFetch = (fetchCenterData: any) => {
	const data = {
		GetAllCenterListToken: fetchCenterData,
	};
	const url = `${API_URL}fetchAllCenterList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL CENTER LIST END *********************** */

/** ***************** GET ALL INVESTOR LIST START *********************** */
export const allInvestorFetch = (fetchData: any) => {
	const data = {
		GetAllInvestorListToken: fetchData,
	};
	const url = `${API_URL}fetchInvestorList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL INVESTOR LIST END *********************** */

/** ***************** GET ALL GROUP LIST START *********************** */
export const fetchallGroup = (fetchData: any) => {
	const data = {
		GetAllGroupListToken: fetchData,
	};
	const url = `${API_URL}fetchAllGroupList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL GROUP LIST END *********************** */

/** ***************** GET ALL GROUP CENTER LIST START *********************** */
export const fetchGroupCenterFetch = (fetchGroupCenterData: any) => {
	const data = {
		FetchAllGroupKeyToken: fetchGroupCenterData,
	};
	const url = `${API_URL}getAllGroupOnLocation`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL GROUP CENTER LIST END *********************** */

/** ***************** GET ALL GROUP MEMBER LIST START *********************** */
export const fetchGroupMembersFetch = (fetchGroupMemberData: any) => {
	const data = {
		GetGroupMemberListToken: fetchGroupMemberData,
	};
	const url = `${API_URL}getAllGroupMemberList`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL GROUP MEMBER LIST END *********************** */

/** ***************** GET ALL BRANCH ACCOUNT LIST START *********************** */
export const BranchAccountListFetch = (fetchAccountDayBookReport: any) => {
	const data = {
		BranchAccountPostDataToken: fetchAccountDayBookReport,
	};
	const url = `${API_URL}GetCompanyFinanceAccountTypeListToken`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL BRANCH ACCOUNT LIST END *********************** */

/** ***************** GET ALL LOAN INDEX LIST START *********************** */
export const fetchGroupLoanIndexListAPI = (encodeData: any) => {
	const data = {
		GetAllLoanIndexListToken: encodeData,
	};
	const url = `${API_URL}getLoanIndexListBasedOnGroup`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL LOAN INDEX LIST END *********************** */

/** ***************** GET ALL SEARCH LOAN INDEX DETAILS LIST START *********************** */
export const fetchSearchLoanIndexListAPI = (encodeData: any) => {
	const data = {
		SearchLoanIndexDetailsTokenDataToken: encodeData,
	};
	const url = `${API_URL}SearchProductLoanIndexDetailsToken`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL SEARCH LOAN INDEX DETAILS LIST END *********************** */

/** ***************** GET VERSION DETAILS START *********************** */
export const VersionDetailsFetch = (posatData: any) => {
	const data = {
		GetVersionDataToken: posatData,
	};
	const url = `${API_URL}GetVersionDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET VERSION DETAILS END *********************** */

/** ***************** UPDATE VERSION DETAILS START *********************** */
export const VersionDetailsUpdate = (posatData: any) => {
	const data = {
		UpdateVersionDataToken: posatData,
	};
	const url = `${API_URL}UpdateVersionDetails`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE VERSION DETAILS END *********************** */

/** ***************** GET PINCODE DETAILS START *********************** */
export const PincodeDetailsFetch = (posatData: any) => {
	const data = {
		FetchPincodeListToken: posatData,
	};
	const url = `${API_URL}FetchPincodeDetails`;
	return makeApiCall(url, data);
};
/** ***************** GET PINCODE DETAILS END *********************** */

/** ***************** GET ALL LOCATION LIST BASED LEVEL START *********************** */
export const getAllLocationListBasedLevel = (encodeData: any) => {
	const data = {
		AllLocationBasedLevelToken: encodeData,
	};
	const url = `${API_URL}GetAllLocationListBasedLevel`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL LOCATION LIST BASED LEVEL END *********************** */

/** ***************** CHECK AUTHENTICATION KEY START *********************** */
export const checkAuthenticationKeyAPI = (encodeData: any) => {
	const data = {
		CheckUserAuthToken: encodeData,
	};
	const url = `${API_URL}CheckAuthentication`;
	return makeApiCall(url, data);
};
/** ***************** CHECK AUTHENTICATION KEY END *********************** */

/** ***************** GET ALL PURPOSE OF LOAN PROPOSAL LIST START *********************** */
export const getAllPurposeOfLoanProposalList = (encodeData: any) => {
	const data = {
		getAllPurposeOfLoanListDetailsToken: encodeData,
	};
	const url = `${API_URL}GetAllPurposeofLoanWithToken`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL PURPOSE OF LOAN PROPOSAL LIST END *********************** */

/** ***************** GET ALL OFFICER BASED LEVEL LIST START *********************** */
export const getAllOfficerBesedOnLevelListProposal = (encodeData: any) => {
	const data = {
		GetAllOfficerUserBasedOnLevelDataToken: encodeData,
	};
	const url = `${API_URL}GetAllOfficerUserBasedOnLevelToken`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL OFFICER BASED LEVEL LIST END *********************** */

/** ***************** GET ALL THRIFT LIST PROPOSAL START *********************** */
export const getAllThriftListProposal = (encodeData: any) => {
	const data = {
		getAllThriftListToken: encodeData,
	};
	const url = `${API_URL}GetAllThriftListWithToken`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL THRIFT LIST PROPOSAL END *********************** */

/** ***************** GET ALL THRIFT DETAILS START *********************** */
export const getAllThriftDetails = (encodeData: any) => {
	const data = {
		GetThriftDetailsDataToken: encodeData,
	};
	const url = `${API_URL}GetThriftDetailsToken`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL THRIFT DETAILS END *********************** */

/** ***************** GET ALL NON APPROVE MEMBERS DETAILS START *********************** */
export const getAllNonApproveMembersDetails = (encodeData: any) => {
	const data = {
		FetchAllNonApproveMembersToken: encodeData,
	};
	const url = `${API_URL}getAllNonApproveMembers`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL NON APPROVE MEMBERS DETAILS END *********************** */

/** ***************** GET ALL GOLD PRICE START *********************** */
export const todayGoldPriceGet = (listData: any) => {
	const data = {
		GetTodayGoldPriceToken: listData,
	};
	const url = `${API_URL}TodayGoldPriceGet`;
	return makeApiCall(url, data);
};
/** ***************** GET ALL GOLD PRICE END *********************** */

/** ***************** UPDATE GOLD PRICE START *********************** */
export const todayGoldPriceUpdate = (listData: any) => {
	const data = {
		UpdateTodayGoldPriceToken: listData,
	};
	const url = `${API_URL}TodayGoldPriceUpdate`;
	return makeApiCall(url, data);
};
/** ***************** UPDATE GOLD PRICE END *********************** */
/** ***************** GET STATEWISE BRANCHES START *********************** */
export const StatewiseBranchDetails = (addData: any) => {
	const data = {
		FetchLoadAdminAreaToken: addData,
	};
	console.log({ API_URL });
	const url = `${API_URL}LoadAdminAreaList`;
	return makeApiCall(url, data);
};
/** ***************** GET STATEWISE BRANCHES END *********************** */
